import {CreateAdHocQuestion, QuestionId} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function get(questionId: QuestionId) {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/vendor_toolkit/adhoc_questions/{question_id}",
    {path: {question_id: questionId}},
  );
}

export async function list() {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/adhoc_questions`, {});
}

export async function create(question: CreateAdHocQuestion) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/adhoc_questions`, {
    body: question,
  });
  await invalidateQueries([q.vendorToolkit.adhocQuestions.filter(), q.vendorToolkit.tasks.filter()]);
  return res;
}
